import { BurgerIcon, CloseIcon } from '@web_opxp/icons';
import * as React from 'react';
import Logo from '../logo';
import NavBar from '../navBar';
import './Header.scss';

export interface IHeaderProps {
  logoLink?: string;
  logoSrc?: string;
  logoLabel?: string;
  slim?: boolean;
  className?: string;
}

export const Header: React.FC<React.PropsWithChildren<IHeaderProps>> = ({
  logoLink,
  logoSrc,
  logoLabel,
  slim,
  children,
  className,
}) => {
  const [isOpen, openMenu] = React.useState(false);
  const buttonClickHandler = () => openMenu(!isOpen);
  const slimClass = slim ? ' slim' : '';
  const buttonIcon = isOpen ? <CloseIcon /> : <BurgerIcon />;
  const openStateClass = isOpen ? ' open' : ' closed';
  const customClass = className ? ` ${className}` : '';
  const headerClass = `header${slimClass}${openStateClass}${customClass}`;
  const logo = logoLink ? (
    <a href={logoLink} className="logo-link">
      <Logo className="header-logo" logoLabel={logoLabel} logoSrc={logoSrc} />
    </a>
  ) : (
    <span className="logo-link">
      <Logo className="header-logo" logoLabel={logoLabel} logoSrc={logoSrc} />
    </span>
  );
  const isEmpty = !children;
  const toggleButton = isEmpty ? null : (
    <button type="button" className="nav-toggle" onClick={buttonClickHandler}>
      {buttonIcon}
    </button>
  );
  const navMenu = isEmpty ? null : (
    <div className="header-collapsible">
      <NavBar className="header-nav">{children}</NavBar>
    </div>
  );
  return (
    <header className={headerClass}>
      <div className="container">
        <div className="header-common">
          {logo}
          {toggleButton}
        </div>
        {navMenu}
      </div>
    </header>
  );
};

export default Header;
